import CDynamicComponent from './dynamic-component.vue';
export default CDynamicComponent;
